/**
 * Labstep
 *
 * @module components/EntityStateWorkflow/Form/ShowEdit/Name
 * @desc EntityStateWorkflow update name
 */

import { EntityPrimaryInfo } from 'labstep-web/components/Entity/PrimaryInfo';
import { ICONS } from 'labstep-web/constants/icons';
import type React from 'react';
import type { EntityStateWorkflowFormShowEditNameProps } from './types';

export const EntityStateWorkflowFormShowEditName: React.FC<
  EntityStateWorkflowFormShowEditNameProps
> = ({ entityStateWorkflow }) => (
  <EntityPrimaryInfo
    entity={entityStateWorkflow}
    icon={ICONS.entity_state_workflow.primary}
    name={entityStateWorkflow.name}
  />
);
